<template>
  <nav
    class="py-8 overflow-scroll rounded-md timeline p-6 border
    border-blue-500 w-auto"
  >
    <ul class="mt-8" v-if="elementsPresent">
      <svg xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-8 w-8 mr-4 mt-1 outline-none"
        :class="{'text-blue-500': canUndo, 'text-gray-400': !canUndo}"
        v-tooltip="'Undo'"
        @click="undoNarrative"
      >
        <path d="M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1"></path>
      </svg>
      <draggable v-model="elements"  handle=".draggable" :move="checkMove" group="list">
        <time-point
          :adder="true"
          :element="element"
          v-for="(element) in elements"
          :key="element.Oid"
          v-on:add-element="addElement"
          :class="{ draggable: element.type != 'TITLE'}"
        ></time-point>
      </draggable>
      <e-plus
        :final-element="true"
        v-on:add-element="addElement"
        :rank="elements.length"
      ></e-plus>
    </ul>
    <ul v-else>
      <e-plus
        :final-element="true"
        :solo="true"
        v-on:add-element="addElement"
        :rank="0"
      ></e-plus>
    </ul>
  </nav>
</template>

<script>
// import Component from "../component_location"
import TimePoint from "./TimePoint.vue";
import draggable from "vuedraggable";
import EPlus from "./EPlus.vue";
import { reportError, EventBus } from "@/utils.js";

// import ElementPicker from "./ElementPicker.vue";

export default {
  components: { TimePoint, draggable, EPlus },

  props: ["narrative"],

  data() {
    return {
      linkableTypes: ["IMAGE", "TEXT", "VIDEO", "AUDIO"],
    };
  },

  watch: {},

  methods: {
    addElement(elementDetails) {
      if (elementDetails.type == "TITLE" && this.titlePresent) {
         this.$store.dispatch('modals/showError', { message: 'Title element already exists! (One title element per narrative allowed)' });
        return;
      }
      let details = {
        narrativeId: this.narrative.Oid,
        elementType: elementDetails.type,
        elementRank: elementDetails.type == "TITLE" ? 0 : elementDetails.rank,
      };
      this.$store.dispatch("narratives/createElement", details);
    },
    checkLinkability(elements) {
      // Determine if successive elements can be linked.
      var idx = 0;
      var lt = this.linkableTypes;
      for (var idx = 1; idx < elements.length; idx++) {
        var current = elements[idx];
        var prev = elements[idx - 1];
        let notBackgrounds = (!prev.isBackground && !current.isBackground)
        if (lt.includes(current.type) && lt.includes(prev.type) && notBackgrounds) {
          current.isLinkable = true;
        } else {
          current.isLinkable = false;
        }
      }
      return elements;
    },

    undoNarrative() {
      if(this.canUndo) {
        this.$store.dispatch("narratives/undoNarrative");
      }
    },
    checkMove(e) {
      return this.isDraggable(e.draggedContext);
    },

    isDraggable(context) {
      const { index, futureIndex } = context
      return !(this.elements[index].type == 'TITLE' || this.elements[futureIndex].type == 'TITLE');
    }
  },

  computed: {
    elements: {
      get: function() {
        var elements = this.checkLinkability(
          this.$store.state.narratives.current.elements
        );
        return elements
      },
      set: function(elements) {
        // this.$store.state.narratives.current.elements = elements
        this.$store.dispatch("narratives/updateElementOrder", elements);
      },
    },

    elementsPresent() {
      if (this.elements) {
        return this.elements.length > 0;
      } else {
        return false;
      }
    },

    titlePresent() {
      for (var idx = 0; idx < this.elements.length; idx++) {
        if (this.elements[idx].type == "TITLE") {
          return true;
        }
      }
      return false;
    },

    canUndo() {
      return this.$store.state.narratives.narrativeHistory.length > 0;
    }
  },

  mounted() {},
};
</script>

<style>
.timeline {
  height: 600px;
}
</style>
